import { render, staticRenderFns } from "./TipoDicasSaude.vue?vue&type=template&id=1f23db20&scoped=true&"
import script from "./TipoDicasSaude.vue?vue&type=script&lang=js&"
export * from "./TipoDicasSaude.vue?vue&type=script&lang=js&"
import style0 from "./TipoDicasSaude.vue?vue&type=style&index=0&id=1f23db20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f23db20",
  null
  
)

export default component.exports